var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.37,
    height: 15.527,
    viewBox: "0 0 23.37 15.527",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-outline",
    transform: "translate(-31.224 -111.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37285",
    "data-name": "Path 37285",
    d: "M42.892,112c-3.8,0-7.69,2.2-10.756,6.591a.779.779,0,0,0-.013.865c2.355,3.687,6.2,6.57,10.769,6.57,4.522,0,8.443-2.892,10.8-6.587a.786.786,0,0,0,0-.851C51.33,114.936,47.38,112,42.892,112Z",
    fill: "none",
    stroke: "#747474",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(39.9 116.013)",
    fill: "none",
    stroke: "#747474",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOutline);
export default __webpack_public_path__ + "static/media/eye-outline.02e9ac896875ac49903efe8bef07e3e3.svg";
export { ForwardRef as ReactComponent };